import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css'
import {useLazyResetPasswordQuery, useResetPasswordPostMutation} from "../services/endpoints/user.api";
const ChangePassword = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const resetKey = searchParams.get("key");
    const [email, setEmail] = useState('');
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const [showSuccess, setShowSuccess] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [errorMessage, setErrorMessage] = useState(null); // <-- errore locale
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);

    useEffect(() => {
        if (!resetKey) {
            setErrorMessage("Link di reset non valido o mancante.");
            setShowForm(false)
        }
    }, [resetKey]);
    const validatePassword = (pwd) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        return regex.test(pwd);
    };
    const [changePassword,{ isLoading, isSuccess } ]= useResetPasswordPostMutation();
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await changePassword({resetKey, password }).unwrap();

            // Se arriva qui, il backend ha risposto con 200
            console.log("Successo:", res);
            setShowSuccess(true);
        } catch (error) {
            console.error("Errore durante il reset password:", error);
            alert("Errore durante l'invio della richiesta.");
        }
    };

    return (
        <div>
            <Header/>
            <main className="container form-signin w-50 pt-5 m-sm-auto text-center">
                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}
                    </div>
                )}
                {showSuccess && (
                    <div className="alert alert-success mt-3">
                        Password cambiata con successo!
                    </div>
                )}
                { showForm ? (
                <form onSubmit={handleSubmit}>


                    <div className="form-floating mb-3 position-relative">
                        <input
                            type={passwordVisible ? "text" : "password"}
                            className={`form-control ${password ? (passwordValid ? "is-valid" : "is-invalid") : ""}`}
                            id="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => {
                                const pwd = e.target.value;
                                setPassword(pwd);
                                setPasswordValid(validatePassword(pwd));
                            }}
                            required
                        />
                        <label htmlFor="password">Nuova Password</label>

                        {/* Toggle visibilità */}
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary top-50 position-absolute end-0 translate-middle-y me-5 border-0"
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            tabIndex={-1}
                        >
                            {passwordVisible ? "🙈" : "👁️"}
                        </button>

                        {/* Mostra feedback solo se l'utente ha digitato qualcosa */}
                        {password && (
                            <>
                                {!passwordValid ? (
                                    <div className="invalid-feedback text-start d-block">
                                        Min. 8 caratteri, 1 maiuscola, 1 minuscola, 1 numero, 1 simbolo.
                                    </div>
                                ) : (
                                    <div className="valid-feedback text-start d-block">Password valida</div>
                                )}
                            </>
                        )}
                    </div>

                    <div className="valid-feedback text-start">Password valida</div>


                    <div className="form-floating mb-3">
                        <input
                            type="password"
                            className="form-control"
                            id="password2"
                            placeholder="Password"
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingPassword">Ripeti nuova password</label>
                    </div>

                    <button className="btn btn-primary w-100 py-2" type="submit" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Reset in corso...
                            </>
                        ) : (
                            "Conferma"
                        )}
                    </button>
                    <p className="mt-5 mb-3 text-body-secondary">CiSono© {new Date().getFullYear() }</p>
                </form>) : (<p></p>)
                }
            </main>
            <Footer />
        </div>
    );

};

export default ChangePassword;
